import { Button, FormHelperText, Grid, InputAdornment, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/styles';
import { isValidURL } from 'helper/string.helper';
let errorMessageLink = {
    title: '',
    url: ''
};
let isInputChange = false;
const AddEditCompanyLink = ({ formData, setFormData, handleFormSubmit, handleCancel }) => {
    const theme = useTheme();
    const checkIsFormDisabled = () => {
        if (!isInputChange) return true;
        if (!formData?.title || !formData?.url) {
            if (!formData?.title) errorMessageLink.title = 'Please provide a title of the link.';
            else errorMessageLink.title = '';
            if (!formData?.url) {
                errorMessageLink.url = 'Please provide a link.';
            } else {
                errorMessageLink.url = '';
            }
            return true;
        }
        if (!isValidURL(formData?.url)) {
            errorMessageLink.url = 'Please provide a valid link.';
            errorMessageLink.title = '';
            return true;
        }
        errorMessageLink = {
            title: '',
            url: ''
        };
        return false;
    };
    return (
        <>
            <Grid container spacing={2} className="profile-fields">
                <Grid item xs={6}>
                    <TextField
                        label="Link title"
                        value={formData.title}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">{formData?.title?.length || 0}/35</InputAdornment>
                        }}
                        onChange={(e) => {
                            if (e.target.value.length > 35) return;
                            setFormData({ ...formData, title: e.target.value });
                            isInputChange = true;
                        }}
                        fullWidth
                        sx={{ ...theme.typography.customInput }}
                    />
                    {errorMessageLink.title && <FormHelperText error> {errorMessageLink.title}</FormHelperText>}
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label="Link"
                        value={formData.url}
                        onChange={(e) => {
                            setFormData({ ...formData, url: e.target.value });
                            isInputChange = true;
                        }}
                        fullWidth
                        sx={{ ...theme.typography.customInput }}
                    />
                    {errorMessageLink.url && <FormHelperText error> {errorMessageLink.url}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {/* {formData._id && ( */}
                    <Button
                        onClick={() => {
                            handleCancel();
                            errorMessageLink = { title: '', url: '' };
                            isInputChange = false;
                        }}
                        sx={{ mr: 1 }}
                        className="alternate-reversed large"
                    >
                        Cancel
                    </Button>
                    {/* )} */}
                    <Button
                        onClick={() => {
                            handleFormSubmit();
                            errorMessageLink = { title: '', url: '' };
                            isInputChange = false;
                        }}
                        className="alternate large"
                        disabled={checkIsFormDisabled()}
                    >
                        Save changes
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};
export default AddEditCompanyLink;
